import SquaresModalShell, {
  SquaresModalTitle,
  SquaresPrimaryButton,
  SquaresOutlineButton,
} from './SquaresModalShell';

export interface ConfirmReserveModalProps {
  /** Is the modal open */
  isOpen: boolean;
  /** Close/cancel handler */
  onClose: () => void;
  /** Confirm handler — fires the reserve mutation */
  onConfirm: () => void;
  /** Contest name shown above the CTA */
  contestName?: string;
  /** Prize pool label (e.g. "$500") */
  prizePool?: string;
  /** Disables both buttons while the reserve request is in flight */
  isSubmitting?: boolean;
}

/**
 * "Confirm Entry" modal for Reserve a Seat (DKPLAT-529) — Squares parity with
 * Pick'em's ConfirmEntryModal (DKPLAT-528).
 */
export default function ConfirmReserveModal({
  isOpen,
  onClose,
  onConfirm,
  contestName,
  prizePool,
  isSubmitting = false,
}: ConfirmReserveModalProps) {
  return (
    <SquaresModalShell
      isOpen={isOpen}
      onClose={onClose}
      testId="confirm-reserve-modal"
      closeDisabled={isSubmitting}
    >
      <SquaresModalTitle>Confirm Entry</SquaresModalTitle>

      {contestName && (
        <p
          className="text-zinc-200"
          style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', lineHeight: '20px' }}
        >
          {contestName}
        </p>
      )}

      {prizePool && (
        <p className="text-sm text-zinc-400">
          Prize Pool: <span className="font-bold text-[#53d337]">{prizePool}</span>
        </p>
      )}

      <p
        className="text-zinc-300"
        style={{ fontFamily: 'Inter, sans-serif', fontSize: '13px', lineHeight: '18px' }}
      >
        Reserving holds your seat now. You'll still need to come back and pick your squares once
        they're posted.
      </p>

      <div className="space-y-3">
        <SquaresPrimaryButton
          testId="confirm-reserve-submit-btn"
          onClick={onConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'RESERVING…' : 'RESERVE SEAT | FREE'}
        </SquaresPrimaryButton>
        <SquaresOutlineButton
          testId="confirm-reserve-cancel-btn"
          onClick={onClose}
          disabled={isSubmitting}
        >
          CANCEL
        </SquaresOutlineButton>
      </div>
    </SquaresModalShell>
  );
}
